/**
 * Try to extract string from localisation file.
 * @param id Key to be searched for.
 * @param language Contains key-value pairs of active language.
 */
export const transl = (
  id: string,
  language: { [key: string]: string | null | undefined }
) => language[id] ?? id;
